// Префикс для сообщений в кросс-фреймовой коммуникации виджетов через postMessage
export const IFRAME_MESSAGE_PREFIX = 'tripster-iframe';

// Параметры виджета задающие источник списка экскурсий (география, гид, произвольный список)
export const WIDGET_SOURCE_PARAMS = [
  'country',
  'city',
  'iata',
  'geonames_id',
  'guide',
  'experiences',
  'tag',
  'citytag',
  'region',
];

// Разрешённые параметры для передачи в iframe виджета
export const ALLOWED_WIDGET_PARAMS = [
  ...WIDGET_SOURCE_PARAMS,
  'widget_template',
  'template',
  'mobile',
  'partner',
  'subpartner',
  'redirect',
  'widgetbar',
  'q',
  'order',
  'num',
  'label',
  'styles',
  'bg_color',
  'button_text',
  'font_size',
  'features',
  'debug',
  'script_id',
  'iframe_id',
  'version',
  'experiment',
  'view',
  'type',
  'licensed',
  'replace_missing_ids',
];

export const WIDGET_TYPES = {
  TOUR: 'tour',
};

export const WIDGET_MODES = {
  EXPERIENCES: 'experiences', // Конкретные экскурсии по ID
  CITY: 'city', // Экскурсии города
  REGION: 'region', // Экскурсии регион
  COUNTRY: 'country', // Экскурсии страны
  GUIDE: 'guide', // Экскурсии гида

  EXPERIENCES_TOURS: 'experiences_tours', // Конкретные туры по id
  CITY_TOURS: 'city_tours', // Туры города
  REGION_TOURS: 'region_tours', // Туры региона
  COUNTRY_TOURS: 'country_tours', // Туры страны
  GUIDE_TOURS: 'guide_tours', // Туры гида

  CITYTAG: 'citytag', // Экскурсии по рубрике города

  CITY_SEARCH: 'city_search', // Город + поиск по экскурсиям
  COUNTRY_SEARCH: 'country_search', // Страна + поиск по экскурсиям
  REGION_SEARCH: 'region_search', // Регион + поиск по экскурсиям

  CITY_SEARCH_TOURS: 'city_search_tours', // Город + поиск по турам
  COUNTRY_SEARCH_TOURS: 'country_search_tours', // Страна + поиск по турам
  REGION_SEARCH_TOURS: 'region_search_tours', // Регион + поиск по турам

  PLUG: 'plug', // Заглушка
};

export const ALLOWED_MARKS = [
  'utm_source',
  'utm_campaign',
  'utm_medium',
  'utm_content',
  'utm_term',
  'exp_partner',
  'exp_subpartner',
];

export const DEFAULT_PARTNER_MARKS = {
  utm_campaign: 'affiliates',
  utm_medium: 'widget',
};
